import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableRow from './TableRow';

export default class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  tableLabels = () => {
    return Object.keys(this.props.data[0]);
  };

  render() {
    return (
      <table className="table" data-test-table>
        <thead>
          <tr>
            {this.tableLabels().map((label) => (
              <th title={label} key={label}>
                {label}
              </th>
            ))}
            <th title="actions">Edit Role:</th>
          </tr>
        </thead>
        <tbody>
          {this.props.data.map((user) => {
            return (
              <TableRow
                data={this.props.data}
                editableRoles={this.props.editableRoles}
                user={user}
                handleSubmit={this.props.handleSubmit}
              />
            );
          })}
        </tbody>
      </table>
    );
  }
}

Table.propTypes = {
  data: PropTypes.array.isRequired,
};
